import React from "react";
import ZImage from "../ZImage";
import ZomentumLogo from "config/assets/ZomentumLogo.gif";

const ZContentLoadingIcon: React.FC<{
	loading_icon?: string;
}> = ({ loading_icon }) => {
	return (
		<div className="h-full flex justify-center items-center">
			<ZImage
				className="loading-icon"
				preview={false}
				src={loading_icon ?? ZomentumLogo}
				alt="Loading"
			/>
		</div>
	);
};

export default ZContentLoadingIcon;
